import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MembershipPluginsService } from '@common/membership/shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { AccessState, CoreFrontendSharedModule } from '@core/frontend-shared';
import { Store } from '@ngxs/store';
import { combineLatest, map } from 'rxjs';
import { MembershipRegistrationFacade, MembershipRegistrationMode, MembershipRegistrationState, RegistrationStep } from '../state';
import * as i0 from "@angular/core";
import * as i1 from "../state";
import * as i2 from "@common/membership/shared";
import * as i3 from "@angular/router";
import * as i4 from "@angular/common";
function RegistrationCompleteComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "Die Registrierung konnte nicht abgeschlossen werden.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "ui-message", 0);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 1);
    i0.ɵɵlistener("click", function RegistrationCompleteComponent_Conditional_0_Conditional_0_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.backToForm());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const status_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", status_r3.submissionError, " ");
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const status_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Fehlermeldung: ", status_r3.paymentError);
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "Zahlung war nicht erfolgreich");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "ui-message", 2)(3, "p");
    i0.ɵɵtext(4, "Ihre Mitgliedschaft wurde erstellt, ist aber noch nicht nutzbar, da es w\u00E4hrend der Zahlung einen Fehler gab.");
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(5, RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_0_Conditional_5_Template, 2, 1, "p");
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtext(7, "Kontaktieren Sie bitte unseren Support, um Ihre Mitgliedschaft zu aktivieren.");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const status_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(status_r3.paymentError ? 5 : -1);
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_0_Conditional_2_Template_button_click_0_listener() {
      const actionBtn_r5 = i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.actionButtonNavigation(actionBtn_r5.link));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("label", ctx.label);
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "Ihre Mitgliedschaft wurde erstellt!");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(2, RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_0_Conditional_2_Template, 1, 1, "button", 3);
    i0.ɵɵpipe(3, "async");
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_5_0 = i0.ɵɵpipeBind1(3, 1, ctx_r1.dynamicButton$)) ? 2 : -1, tmp_5_0);
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_1_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_1_Conditional_2_Conditional_2_Template_button_click_0_listener() {
      const actionBtn_r7 = i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r1.actionButtonNavigation(actionBtn_r7.link));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("label", ctx.label);
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Ihre Registrierung wurde abgeschlossen und Ihre Mitgliedschaft wurde aktiviert. Viel Erfolg beim Lernen!.");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(2, RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_1_Conditional_2_Conditional_2_Template, 1, 1, "button", 3);
    i0.ɵɵpipe(3, "async");
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_6_0 = i0.ɵɵpipeBind1(3, 1, ctx_r1.dynamicButton$)) ? 2 : -1, tmp_6_0);
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "Registrierung erfolgreich");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(2, RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_1_Conditional_2_Template, 4, 3);
  }
  if (rf & 2) {
    const status_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!status_r3.submissionResponse.paymentPending ? 2 : -1);
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_0_Template, 4, 3);
    i0.ɵɵconditionalCreate(1, RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Conditional_1_Template, 3, 1);
  }
  if (rf & 2) {
    const status_r3 = i0.ɵɵnextContext(2);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(status_r3.mode === ctx_r1.MembershipRegistrationMode.registered ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(status_r3.mode === ctx_r1.MembershipRegistrationMode.create ? 1 : -1);
  }
}
function RegistrationCompleteComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_0_Template, 8, 1)(1, RegistrationCompleteComponent_Conditional_0_Conditional_1_Conditional_1_Template, 2, 2);
  }
  if (rf & 2) {
    const status_r3 = i0.ɵɵnextContext();
    i0.ɵɵconditional(status_r3.paymentError || status_r3.paymentPending ? 0 : 1);
  }
}
function RegistrationCompleteComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationCompleteComponent_Conditional_0_Conditional_0_Template, 5, 1);
    i0.ɵɵconditionalCreate(1, RegistrationCompleteComponent_Conditional_0_Conditional_1_Template, 2, 1);
  }
  if (rf & 2) {
    const status_r3 = ctx;
    i0.ɵɵconditional(status_r3.submissionError ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(status_r3.submissionResponse && !status_r3.submissionError ? 1 : -1);
  }
}
export let RegistrationCompleteComponent = /*#__PURE__*/(() => {
  class RegistrationCompleteComponent {
    constructor(registration, pluginsService, router) {
      this.registration = registration;
      this.pluginsService = pluginsService;
      this.router = router;
      this.loggedIn$ = inject(Store).select(AccessState.loggedIn);
      this.mode$ = inject(Store).select(MembershipRegistrationState.mode);
      this.paymentError$ = inject(Store).select(MembershipRegistrationState.paymentError);
      this.submissionError$ = inject(Store).select(MembershipRegistrationState.submissionError);
      this.submissionResponse$ = inject(Store).select(MembershipRegistrationState.submissionResponse);
      this.requireAccountData$ = inject(Store).select(MembershipRegistrationState.requireAccountData);
      this.credentialsByMail$ = inject(Store).select(MembershipRegistrationState.credentialsByMail);
      this.membershipType$ = inject(Store).select(MembershipRegistrationState.membershipType);
      this.activePlugin$ = this.membershipType$.pipe(map(type => this.pluginsService.getPluginInstance(type)));
      this.dynamicButton$ = this.activePlugin$.pipe(map(plugin => {
        if (plugin.getRegistrationCompletedButton) {
          return plugin.getRegistrationCompletedButton();
        }
        return null;
      }));
      this.MembershipRegistrationMode = MembershipRegistrationMode;
      this.status$ = combineLatest({
        mode: this.mode$,
        loggedIn: this.loggedIn$,
        paymentError: this.paymentError$,
        submissionError: this.submissionError$,
        submissionResponse: this.submissionResponse$
      });
    }
    backToForm() {
      this.registration.setPluginFormState(null);
      this.registration.goToStep(RegistrationStep.forms);
    }
    goToLogin() {
      // Issue: registration may be on same page as login. In this case, the button wont do anything cause route is already activated.
      // this.router.navigate(this.routerLinkResolver.resolveRouterLink('login'))
    }
    actionButtonNavigation(link) {
      this.router.navigate(link);
    }
    static {
      this.ɵfac = function RegistrationCompleteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegistrationCompleteComponent)(i0.ɵɵdirectiveInject(i1.MembershipRegistrationFacade), i0.ɵɵdirectiveInject(i2.MembershipPluginsService), i0.ɵɵdirectiveInject(i3.Router));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: RegistrationCompleteComponent,
        selectors: [["membership-registration-complete"]],
        decls: 2,
        vars: 3,
        consts: [["type", "error"], ["uiButton", "", "label", "Zur\u00FCck zum Formular", 3, "click"], ["type", "warn"], ["uiButton", "", 3, "label"], ["uiButton", "", 3, "click", "label"]],
        template: function RegistrationCompleteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, RegistrationCompleteComponent_Conditional_0_Template, 2, 2);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.status$)) ? 0 : -1, tmp_0_0);
          }
        },
        dependencies: [CoreFrontendSharedModule, CommonModule, UiButtonComponent, UiMessageComponent, i4.AsyncPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return RegistrationCompleteComponent;
})();